module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/fonts/basis_grotesque_medium-2ca547ac2e2fab3085b5583fa6346dde.woff2";